export default __webpack_public_path__ + "static/media/lato-black.0808d106.svg";